function getApiOrigin() {
  const base = process.env.VUE_APP_API_BASE_URL || "";
  try {
    return new URL(base).origin;
  } catch (e) {
    return "";
  }
}

export function loginWithGoogle({
  company_label,
  vacancy_id,
  debug,
  channel,
  utm_campaign,
  utm_medium,
  purpose,
} = {}) {
  const apiOrigin = getApiOrigin();
  let redirectUrl = `${process.env.VUE_APP_API_BASE_URL}/api/v2/auth/social-login/google/redirect?origin=talents`;
  const params = new URLSearchParams();
  if (company_label) params.set("company_label", company_label);
  if (vacancy_id != null) params.set("vacancy_id", String(vacancy_id));
  if (debug === true || debug === "true") params.set("debug", "true");
  if (channel) params.set("channel", channel);
  if (utm_campaign) params.set("utm_campaign", utm_campaign);
  if (utm_medium) params.set("utm_medium", utm_medium);
  if (purpose) params.set("purpose", purpose);
  const qs = params.toString();
  if (qs) redirectUrl += `&${qs}`;
  const width = 500;
  const height = 600;
  const left = window.screen.width / 2 - width / 2;
  const top = window.screen.height / 2 - height / 2;
  const popup = window.open(
    redirectUrl,
    "recrutei-google-login",
    `width=${width},height=${height},left=${left},top=${top},scrollbars=yes`
  );

  return new Promise((resolve, reject) => {
    if (!popup || popup.closed) {
      const debug = {
        apiOrigin: apiOrigin || "",
        redirectUrl,
        lastEventOrigin: null,
        lastIgnoredReason: null,
        lastPayload: null,
      };
      reject({
        error: "popup_blocked",
        message: `Popup bloqueado ou não abriu. url=${redirectUrl} apiOrigin=${apiOrigin || "n/a"}`,
        debug,
      });
      return;
    }

    const debug = {
      apiOrigin: apiOrigin || "",
      redirectUrl,
      lastEventOrigin: null,
      lastIgnoredReason: null,
      lastPayload: null,
    };

    let settled = false;

    const handleMessage = (event) => {
      debug.lastEventOrigin = event.origin || null;
      if (apiOrigin && event.origin !== apiOrigin) {
        debug.lastIgnoredReason = `origin_mismatch expected=${apiOrigin} got=${event.origin}`;
        return;
      }
      const data = event.data;
      if (!data || data.type !== "social-login") {
        return;
      }

      debug.lastPayload = data;
      settled = true;
      window.removeEventListener("message", handleMessage);
      if (popup && !popup.closed) {
        popup.close();
      }

      if (data.error) {
        reject({
          error: data.error,
          created_account: data.created_account,
          debug,
        });
        return;
      }
      if (data.token) {
        resolve({
          token: data.token,
          social_reauth_token: data.social_reauth_token != null ? data.social_reauth_token : null,
          created_account: data.created_account === true,
          application_id: data.application_id != null ? data.application_id : null,
          company_label: data.company_label != null ? data.company_label : null,
          vacancy_id: data.vacancy_id != null ? data.vacancy_id : null,
        });
        return;
      }
      if (data.social_reauth_token) {
        resolve({
          token: null,
          social_reauth_token: data.social_reauth_token,
          created_account: false,
          application_id: null,
          company_label: null,
          vacancy_id: null,
        });
        return;
      }
      if (data.action === "needs_registration" || data.action === "needs_password") {
        resolve({
          action: data.action,
          social_token: data.social_token != null ? data.social_token : null,
          user_email: data.user_email != null ? data.user_email : null,
          created_account: false,
          application_id: null,
          company_label: null,
          vacancy_id: null,
        });
        return;
      }
      reject({
        error: "unknown",
        created_account: false,
        debug,
      });
    };

    window.addEventListener("message", handleMessage);

    const checkClosed = setInterval(() => {
      if (popup.closed) {
        clearInterval(checkClosed);
        setTimeout(() => {
          if (settled) return;
          window.removeEventListener("message", handleMessage);
          const details = [
            "Popup fechado sem concluir o login.",
            debug.lastIgnoredReason ? `ignored=${debug.lastIgnoredReason}` : null,
            debug.lastEventOrigin ? `lastOrigin=${debug.lastEventOrigin}` : null,
            debug.apiOrigin ? `apiOrigin=${debug.apiOrigin}` : null,
            `url=${debug.redirectUrl}`,
          ]
            .filter(Boolean)
            .join(" ");
          reject({
            error: "popup_closed",
            message: details,
            debug,
          });
        }, 800);
      }
    }, 500);
  });
}
